import { render, staticRenderFns } from "./AutocompleteModern.vue?vue&type=template&id=69b1b913&"
import script from "./AutocompleteModern.vue?vue&type=script&lang=js&"
export * from "./AutocompleteModern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports